<template>
  <div>
    <v-select
      v-model="selectedValues"
      :options="formattedOptions"
      :multiple="true"
      :clearable="true"
      :disabled="isDisabled"
      :placeholder="placeholder || 'Selecciona opciones...'"
      append-to-body
      :calculate-position="withPopper"
      @input="onChange"
      label="label"
      :reduce="option => option.value"
    />
  </div>
</template>

<script>
import { ref, computed, onMounted, watch } from "@vue/composition-api";
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";

export default {
  name: "MultipleSelect",
  components: {
    vSelect,
  },
  props: {
    id: String,
    name: String,
    label: String,
    options: {
      type: Array,
      default: () => [],
    },
    disabled: Boolean,
    context: Object,
    placeholder: String,
    fieldOptions: Object,
  },
  setup(props, { emit }) {
    const selectedValues = ref([]);
    const isDisabled = ref(false);

    const formattedOptions = computed(() => {
      // format options from props or fieldOptions
      let rawOptions = [];

      if (props.options && Array.isArray(props.options) && props.options.length > 0) {
        rawOptions = props.options;
      } else if (props.fieldOptions && props.fieldOptions.fieldTypeCfg && Array.isArray(props.fieldOptions.fieldTypeCfg.data)) {
        rawOptions = props.fieldOptions.fieldTypeCfg.data;
      }

      const result = rawOptions.map(option => {
        if (option.label && option.value) {
          return {
            label: option.label,
            value: option.value,
          };
        }
        const value = option.value || option.name || option;
        return {
          label: value,
          value: value,
        };
      });

      return result;
    });

    onMounted(() => {
      isDisabled.value = props.context?.attributes?.disabled ?? props.disabled ?? false;

      // initialize from context model
      if (props.context?.model) {
        const modelValue = Array.isArray(props.context.model)
          ? props.context.model
          : [props.context.model];
        const validValues = modelValue.filter(val => val !== null && val !== undefined && val !== '');
        selectedValues.value = validValues.map(val => {
          const option = formattedOptions.value.find(opt => opt.value === val);
          return option || { label: String(val), value: val };
        });
      }
    });

    watch(
      () => props.context?.attributes?.disabled,
      (newValue) => {
        isDisabled.value = newValue ?? props.disabled ?? false;
      },
      { immediate: true }
    );

    watch(
      () => props.context?.model,
      (newValue) => {
        if (newValue !== undefined) {
          const modelValue = Array.isArray(newValue) ? newValue : [newValue];
          const validValues = modelValue.filter(val => val !== null && val !== undefined && val !== '');
          selectedValues.value = validValues.map(val => {
            const option = formattedOptions.value.find(opt => opt.value === val);
            return option || { label: String(val), value: val };
          });
        } else {
          selectedValues.value = [];
        }
      },
      { immediate: true }
    );

    function onChange(value) {
      // extract values from vue-select response
      const values = Array.isArray(value)
        ? value.map(item => typeof item === 'object' && item.value !== undefined ? item.value : item)
        : [];

      if (props.context) {
        props.context.model = values;
      }
      emit("input", values);
    }

    return {
      selectedValues,
      formattedOptions,
      isDisabled,
      onChange,
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>

<style lang="scss" scoped>
.formulate-input-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
}

.formulate-input-help {
  font-size: 0.875rem;
  color: #6c757d;
  margin-top: 0.25rem;
}

.formulate-input-errors {
  margin-top: 0.25rem;
}

.formulate-input-error {
  color: #dc3545;
  font-size: 0.875rem;
}
</style>
